import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router-dom';

export default observer(function AdminPanelLayout() {
    return (
        <>
            <main className='w-screen h-screen bg-bgMain flex justify-center items-center'>
                <Outlet />
            </main>

        </>
    );
});
